var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-container',{staticClass:"px-0",attrs:{"fluid":""}},[_c('div',{staticClass:"position-relative content-div"},[_c('FreeUserTopOffer',{attrs:{"customerInfo":_vm.customerInfo}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }